import { render, staticRenderFns } from "./cusCotStat.vue?vue&type=template&id=8ccb5d12&"
import script from "./cusCotStat.vue?vue&type=script&lang=js&"
export * from "./cusCotStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cusCotStat.vue"
export default component.exports